import * as PROMOTION_END_POINTS from "../constants/endpoints/promotion";
import axios from "../axios/axios";

export const getMechanicBanners = (mechanicId) => {
  return axios({
    url: `${PROMOTION_END_POINTS.GET_MECHANIC_BANNERS}/${mechanicId}`,
    method: "GET",
  });
};
